export const accountPermissions = {
  TRANSFER_ITEM: 'item-transfer',
  VOID_ORDER: 'order-void',
  CANCEL_ORDER: 'order-cancel',
};
